import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { environment } from 'src/environments/environment';
import { Config } from '../models/config.model';
import { BuyingGroups } from '../models/buying-groups.model';
import { ConfigService } from './config.service';
import { InfoCardsService } from './info-card.service';
import { Observable, of, tap, take } from 'rxjs';
import { UserDetails } from '../models/user-details';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import themes from 'devextreme/ui/themes';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class StartupService {

  private apiUrl = environment.baseApiUrl;
  private authApiUrl = environment.authApiUrl;
  private userDetails: UserDetails;
  constructor(private crudService: CrudService,
              private configService: ConfigService,
              private infoCardsService: InfoCardsService,
              private cookieService: CookieService,
              private analytics: AnalyticsService,
              private http: HttpClient) {

               }

  async getHostFileData() {
    this.getUserDetails().subscribe(data => {
      this.userDetails = JSON.parse(JSON.stringify(data));
      document.body.style.backgroundColor = environment.bgColours[data.data.theme];
      localStorage.setItem('theme', data.data.theme === 0 ? 'Light' : 'Dark');
      localStorage.setItem('switchValue', data.data.theme === 0 ? 'false' : 'true');
    });
    this.crudService.getData(`${this.apiUrl}config`).subscribe(async (data: any) => {
      console.log('Config Data: ', data);
      sessionStorage.setItem('ConfigData', JSON.stringify(data));
      const userDetails = localStorage.getItem('userDetails');
      const parsedDetails = JSON.parse(userDetails || '{}');
      const dataArray = Object.values(data);
      const manageInApp = dataArray.find((config: any) => config.config_key === 'ManageCatalogInApp') as Config | undefined;
      if (manageInApp?.config_string === '1') {
        console.log('Catalogue managed in Promoflo — skipping host-file sync');
        return;
      }
      let lastUpdate = '';
      const foundConfig: Config = dataArray.find((config: any) => config.config_key === 'LastHostFileUpdate') as Config;
      if (foundConfig) {
        lastUpdate = foundConfig.config_string;
      } else {
        lastUpdate = '2023-09-11';
      }
      if(lastUpdate < new Date().toISOString().split('T')[0]) {
        const response: BuyingGroups[] = await this.crudService.getData(`${this.apiUrl}buying-groups`).toPromise();
        const data = {
          main_supplier_token: parsedDetails.data.location_token || '',
          date_added: lastUpdate
        }
        response.forEach(BuyingGroup => {
          this.crudService.updateData(`${this.apiUrl}host-data`, BuyingGroup.account_code, data).subscribe((response: any) => {
            console.log('products pricing: ', response);
          });
        });
        // Download products one request per distinct account code (POUR, BACK_BAR, ...).
        // Each call is a separate API Gateway / Lambda invocation that fits the ~29s timeout;
        // downloading every account in a single request previously timed out for large locations.
        // Multiple buying groups can share an account_code, so de-duplicate first.
        const accountCodes = Array.from(new Set(response.map(bg => bg.account_code).filter(Boolean)));
        accountCodes.forEach(accountCode => {
          this.crudService.getData(`${this.apiUrl}host-data?date_added=${lastUpdate}&account_code=${encodeURIComponent(accountCode)}`).subscribe((hostData: any) => {
            console.log('Host Data: ', hostData);
            if(hostData && hostData.success) {
              // Config dates (LastHostFileUpdate + LatestHostFile) are now updated
              // by the API directly during download — refresh the dashboard cards
              this.infoCardsService.refreshInfoCards();
            }
          }, (error: any) => {
            console.log('Error fetching host data: ', error);
          });
        });
      }
    });
  }

  getUserDetails(): Observable<UserDetails> {
      let tokenDetails: any = {};
      if(this.cookieService.get('otd-user')) {
        tokenDetails = JSON.parse(this.cookieService.get('otd-user'));
      } else if(sessionStorage.getItem('user')) {
        const userDetailsString = sessionStorage.getItem('user') || '';
        const userDetails = JSON.parse(userDetailsString);
        tokenDetails.email = userDetails.email;
        tokenDetails.token = sessionStorage.getItem('token') || '';
      } else {
        console.error('User details cookie is missing or empty');
        return of({ data: {} } as UserDetails);
      }
      console.log('User details:', tokenDetails);
      if (!tokenDetails) {
        // Handle the case where the cookie is not set or is empty
        console.error('User details cookie is missing or empty');
        return of({ data: {} } as UserDetails); // Return an empty UserDetails object or handle as needed
      }
      const url = `${this.authApiUrl}user-details?email=${tokenDetails.email}`;
      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + tokenDetails.token
      });
      return this.http.get<UserDetails>(url, { headers, withCredentials: true }).pipe(
        tap(data => {
        themes.current(environment.themes[data.data.theme]);
        document.body.style.backgroundColor = environment.bgColours[data.data.theme];
        localStorage.setItem('userDetails', JSON.stringify(data));
        this.analytics.identify(data.data);
        }),
        take(1)
      );
    }

  // async getConfigData() {
  //   this.configService.getAllConfig().then((data: Config[]) => {
  //     console.log('Config Data: ', data);
  //     sessionStorage.setItem('ConfigData', JSON.stringify(data));
  //   });
  // }

}
